import { TextMessage } from '@helsenorge/framework-utils/types/entities';

import { DEFAULT_ERROR } from '../constants/error';

export const formatErrorMessage = (message?: string): TextMessage => {
  if (message) {
    return {
      Title: message,
      Body: '',
    };
  }
  return DEFAULT_ERROR;
};
